import { useState, useEffect } from 'react'

/* global grecaptcha */

const URL = 'https://www.google.com/recaptcha/enterprise.js'

const Status = {
  Idle: 'Idle',
  Success: 'Success',
  Error: 'Error'
}

const useReCAPTCHASetup = (key = 'null', action = 'login') => {
  const [status, setStatus] = useState(Status.Idle)

  const getToken = async () => {
    if (!window?.grecaptcha) {
      console.error('@google/reCAPTCHA - unable to initiliaze')

      throw new Error('Unable to initiliaze reCAPTCHA')
    }

    await grecaptcha.enterprise.ready(() =>
      console.info('@google/reCAPTCHA - ready')
    )

    try {
      const token = await grecaptcha.enterprise.execute(key, { action })

      setStatus(Status.Success)

      return token
    } catch (error) {
      setStatus(Status.Error)

      throw error
    }
  }

  useEffect(() => {
    const head = document.querySelector('head')
    const script = document.createElement('script')

    script.setAttribute('src', `${URL}?render=${key}`)
    head.appendChild(script)

    return () => {
      head.removeChild(script)
    }
  }, [key])

  return {
    status,
    getToken
  }
}

export default useReCAPTCHASetup
